import { getLocale } from "../runtime";

const sv_viewcampaign = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Till kampanjen`
};

const viewcampaign = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_viewcampaign(inputs)
	return "viewCampaign";
};

export { viewcampaign as "viewCampaign" };